enum TelescopingHelpersEnum {
  "ALL_FALSE" = 99,
  "ALL_ABOVE_TRUE" = 2,
  "ALL_BELOW_TRUE" = 3,
  "ALL_TRUE" = 1,
}

export default TelescopingHelpersEnum;
